import angular from 'angular';

const additionalMoneyFilter = function (value) {
    var priceToDisplay = '';

    if (currency.symbol === 'NOK') {
        priceToDisplay += 'kr ';
    }
    value = Math.ceil(value * currency.factor);
    value = parseInt(value, 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    priceToDisplay += value;

    if (currency.symbol === 'SEK') {
        priceToDisplay += ' kr';
    }
    return priceToDisplay;
}

export default angular.module('additionalMoney', [])
    .filter('additionalMoney', () => additionalMoneyFilter)
    .name;
